import React from 'react';
import AsyncCreatable from 'react-select/async-creatable';

function InputCreatable(props) {
  const {styles, components, ...rest} = props;

  const generateStyles = (customStyles) => ({
    menu: (base) => ({...base, zIndex: 2}),
    control: (styles, state) => ({
      ...styles,
      ...customStyles,
      color: '#6c757d',
      borderRadius: 0,
      borderColor: '#ced4da',
      backgroundColor: state.isDisabled ? '#e9ecef' : 'white',
    }),
    option: (styles, state) => ({
      ...styles,
      ...customStyles,
      borderRadius: 0,
      color: state.isDisabled ? 'inherit' : '$000',
    }),
    input: (styles) => styles,
    placeholder: (styles) => styles,
    singleValue: (styles) => styles,
  });

  return (
    <AsyncCreatable
      components={components}
      styles={generateStyles(styles)}
      {...rest}
    />
  );
}

export default InputCreatable;
